module.exports = yosOptimizely;